import {RootState} from '@/store'
import {Module} from 'vuex'
import {FilterState} from '../types'
import {vuexStorageMutations} from '../utils'

export interface LocalState extends FilterState {

}

const module: Module<LocalState, RootState> = {
  namespaced: true,
  state: {
    except: [],
    only: [
      'auth.accessToken',
      'auth.expiredAt',
      'auth.isPhone',
      'auth.kakaoRefreshToken',
      'auth.kakaoToken',
      'auth.refreshExpiredAt',
      'auth.viewIntro',
      'biz.bizs',
      'userAction.actions',
      'certificates.isRequiredPopup',
    ],
  },
  mutations: {
    ...vuexStorageMutations,
  },
}

export default module
